import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'outpatient-list',
  data: function () {
    return {
      shopId: '',
      outpatientId: null,
      outpatientName: '',
      clinicId: '',
      clinicName: '',
      duplicatedSearch: false,
      searchCallbackFlag: false, // 検索結果フラグ
      watchScroll: null,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'outpatient_name_furigana': {'state': true,  'order': true},
        'sex':                      {'state': false, 'order': false},
        'birthday':                 {'state': false, 'order': false},
        'age':                      {'state': false, 'order': false},
        'patient_code':             {'state': false, 'order': false}
      },
      sortStateInit: {}
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.outpatientsSearchParams !== null) {
        this.$store.getters.outpatientsSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.outpatientsSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created() {
    var readMore = false
    var ssShopID = window.sessionStorage.getItem('dl-shopID')
    var ssOutpatientName = window.sessionStorage.getItem('dl-outpatientName')
    var ssSortKey = window.sessionStorage.getItem("dl-sortKey")
    var ssSortStateOrder = window.sessionStorage.getItem("dl-sortStateOrder")
    if (!!ssShopID) {
      if (ssShopID === 'null') {
        this.shopId = null
      } else {
        this.shopId = ssShopID
      }
    } else {
      this.shopId = this.$store.getters.currentShopId
    }
    if (!!ssOutpatientName) {
      this.outpatientName = ssDocssOutpatientNametorName
    }
    if (!!ssSortKey) {
      var key = ssSortKey
      this.sortKey = key
      if (ssSortStateOrder != null) {
        if (ssSortStateOrder === "true") {
          this.sortStateOrder = true
        } else {
          this.sortStateOrder = false
        }
      } else {
        this.sortStateOrder = !this.sortState[key].order
      }
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = this.sortStateOrder
    }
    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    if (this.shops) {
      this.shopSearch()
    }
    if (!utils.isBlank(this.$route.params.clinicId)) {
      this.clinicId = this.$route.params.clinicId
    }

    this.search(readMore)

    // オートコンプリートイベント
    utils.autocompleteEvent({
      $:                  $,
      elem:               '#clinic_name_autocomplete',
      search:             this.search,
      searchParams:       false,
      searchAutocomplete: this.getClinics,
      setSearchData:      this.setSearchClinic,
      clear:              this.clearClinicsAutocomplete,
    })

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    outpatients() {
      return this.$store.getters.outpatients
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    nextPage() {
      return this.$store.getters.outpatientsNextPage
    },
    totalCount() {
      return this.$store.getters.outpatientsTotalCount
    },
    currentPage () {
      return this.$store.getters.outpatientsCurrentPage
    },
    shops() {
      return this.$store.getters.shops
    },
    /** 通知 */
    notify() {
      return this.$store.getters.outpatientNotify
    }
  },
  methods: {
    goPatientList: function () {
      this.$router.push({ path: '/patients/list' })
    },
    goOutpatientList: function () {
      this.$router.push({ path: '/outpatients/list', query: { type: this.$router.currentRoute.query.type } })
    },
    goNext: function (id) {
      this.$router.push({ path: '/outpatients/detail/' + id, query: { type: this.$router.currentRoute.query.type } })
    },
    goPrev: function () {
      this.$router.push({ path: '/' })
    },
    goNewEdit: function () {
      this.$router.push({ path: '/outpatients/edit' })
    },
    search: function (readMore) {
      var clear = true
      var loadparams = 'true'
      var url = '/outpatients'
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.outpatientsSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.outpatientsSearchParams['scrollHeight']
        this.$store.getters.outpatientsSearchParams['pageYOffset'] = null
        this.$store.getters.outpatientsSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        url = this.$store.getters.outpatientsNextPageLink
        clear = false
        loadparams = 'block'
      } else {
        this.searchCallbackFlag = false
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {
        'shop_id':          this.shopId,
        'outpatient_name':      this.outpatientName,
         'type':             'list',
        'order':            this.orderByString()
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }
      window.sessionStorage.setItem('dl-shopID', this.shopId)
      if (!!this.outpatientName) {
        window.sessionStorage.setItem('dl-outpatientName', this.outpatientName)
      } else {
        window.sessionStorage.removeItem('dl-outpatientName')
      }
      if (!!this.sortKey) {
        window.sessionStorage.setItem("dl-sortKey", this.sortKey)
      } else {
        window.sessionStorage.removeItem("dl-sortKey")
      }
      if (this.sortStateOrder !== "") {
        window.sessionStorage.setItem("dl-sortStateOrder", this.sortStateOrder)
      } else {
        window.sessionStorage.removeItem("dl-sortStateOrder")
      }
      this.$store.dispatch('OUTPATIENT_SEARCH', { url: url, data: data, clear: clear, loadparams: loadparams,callback: callback})
    },
    clearSearchParams: function () {
      if (this.$store.getters.canManage && this.shopId === null) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.outpatientId = null
      this.outpatientName = null
      this.$store.dispatch('OUTPATIENT_CLEAR', 0)
    },
    shopSearch: function () {
      this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('outpatient_name_furigana asc')
      }
      return result.join(' , ')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/outpatient-list.js